module.exports = __webpack_public_path__ + "static/img/lpr.5a8bafd6.jpg";